import React, { createContext, useCallback, useState, useRef } from 'react';

import {
  CadastroComposicaoContextData,
  Composicao,
  ProviderCadComposicaoProps,
  Rows,
  Select,
} from '../types';
import { MasterDetailProps } from '~/utils/masterDetail';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { schema } from '../Validations';

export const initialFormData: Composicao = {
  cod_loja: {
    value: '',
    isInvalid: false,
    isRequired: false,
  },
  cod_produto: {
    value: '',
    isInvalid: false,
    isRequired: false,
  },
  des_produto: {
    value: '',
    isInvalid: false,
    isRequired: false,
  },
  tipo_preco_composicao: {
    value: { label: 'Acompanha a soma dos itens', value: 0 },
    isInvalid: false,
    isRequired: false,
  },
  qtd_composicao: {
    value: '',
    isInvalid: true,
    isRequired: true,
  },
  val_venda: {
    value: 0,
    isInvalid: true,
    isRequired: true,
  },
  val_venda_composicao: {
    value: 0,
    isInvalid: true,
    isRequired: true,
  },
};

export const CadastroComposicaoContext = createContext(
  {} as CadastroComposicaoContextData,
);

export const CadastroComposicaoProvider: React.FC<
  ProviderCadComposicaoProps
> = ({ children }) => {
  const masterDetailDefault = [
    {
      obj_name: 'produtos',
      pk_fields: ['cod_seq_produto_composicao'],
      itens: {
        insert: [],
        update: [],
        delete: [],
      },
    },
  ];
  const tiposDePreco: Select[] = [
    { label: 'Acompanha a soma dos itens', value: 0 },
    { label: 'Informarei o preço da composição', value: 1 },
    { label: 'Informarei o preço de cada item', value: 2 },
  ];
  const [masterDetail, setMasterDetail] =
    useState<MasterDetailProps[]>(masterDetailDefault);
  const [formData, setFormDataState] = useState<Composicao>(initialFormData);
  const [isUpdate, setUpdateState] = useState(false);
  const [valorTotalLoja, setValorTotalLoja] = useState(0);
  const [valorTotalComposicao, setValorTotalComposicao] = useState(0);
  const [valPreco, setValPreco] = useState(0);
  const [codItemEmbalagem, setCodItemEmbalagem] = useState(0);
  const [tipoPrecoComposicao, setTipoPrecoComposicao] = useState<Select>({
    label: 'Acompanha a soma dos itens',
    value: 0,
  });
  const [rows, setRows] = useState<Rows[]>([]);
  const [updateItems, setUpdateItems] = useState<boolean>(false);
  const [explodeVenda, setExplodeVenda] = useState<boolean>(false);
  const containerRef = useRef<HTMLElement | null>(null);

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    clearErrors,
    getValues,
    control,
    setFocus,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    reValidateMode: 'onSubmit',
  });

  const setFormData = useCallback(
    (value: Composicao) => setFormDataState(value),
    [setFormDataState],
  );
  const setUpdate = useCallback(
    (value: boolean) => setUpdateState(value),
    [setUpdateState],
  );

  return (
    <CadastroComposicaoContext.Provider
      value={{
        formData,
        setFormData,
        setUpdate,
        isUpdate,
        tipoPrecoComposicao,
        setTipoPrecoComposicao,
        setMasterDetail,
        masterDetail,
        rows,
        setRows,
        tiposDePreco,
        containerRef,

        register,
        reset,
        setValue,
        handleSubmit,
        clearErrors,
        getValues,
        control,
        setFocus,
        setError,
        errors,
        watch,
        updateItems,
        setUpdateItems,
        valorTotalLoja,
        setValorTotalLoja,
        valorTotalComposicao,
        setValorTotalComposicao,
        codItemEmbalagem,
        setCodItemEmbalagem,
        valPreco,
        setValPreco,

        explodeVenda,
        setExplodeVenda,
      }}
    >
      {children}
    </CadastroComposicaoContext.Provider>
  );
};
